import React, { useState } from 'react';
import { carrierLogoUrl, monogram } from '../../lib/producerPage.js';

/**
 * Carrier logo pulled automatically from the carrier's website domain; falls back
 * to a monogram badge when the logo cannot load.
 * @param {{carrier: {name: string, domain?: string}, size?: number}} props
 */
export default function CarrierLogo({ carrier, size = 40 }) {
  const [failed, setFailed] = useState(false);
  const url = carrierLogoUrl(carrier.domain, carrier.logo);
  return (
    <div className="flex flex-col items-center gap-1.5 w-32 text-center" data-testid={`carrier-logo-${carrier.id}`}>
      {url && !failed ? (
        <img
          src={url}
          alt={`${carrier.name} logo`}
          loading="lazy"
          onError={() => setFailed(true)}
          className="object-contain"
          style={carrier.logo ? { maxHeight: size * 1.5, maxWidth: 120, width: 'auto', height: 'auto' } : { width: size, height: size }}
        />
      ) : (
        <div
          className="rounded-full bg-slate-200 text-slate-600 font-bold flex items-center justify-center"
          style={{ width: size, height: size, fontSize: size / 3 }}
          aria-hidden="true"
        >
          {monogram(carrier.name)}
        </div>
      )}
      <span className="text-[11px] leading-tight text-slate-700 font-medium">{carrier.name}</span>
    </div>
  );
}
